
        import { invitationDestination, resumeMemberOnboarding } from '/src/auth/member-entry.js';
        const invitation = invitationDestination(window.location.href);
        if (invitation) window.location.replace(invitation);
        else {
            import('/src/auth/clerk-session.js').then(async ({ getClerkSession }) => {
                let storage = null;
                try { storage = window.sessionStorage; } catch { /* storage disabled */ }
                await resumeMemberOnboarding(await getClerkSession(), { location: window.location, storage });
            }).catch(() => {});
        }
    